import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import classNames from 'classnames';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import withWidth from 'muiCompat/withWidth';
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from 'react-redux';
import PlayIcon from '@mui/icons-material/PlayArrow';
import Link from '../../../components/Link';
import s from './GoToNextSection.scss';
import messages from '../lessonDetailsMessages';
import intlPropTypes from '../../../constants/intlPropTypes';
var GoToNextSection = (_dec = withStyles(s), _dec2 = withWidth(), _dec3 = connect(function (state) {
  return {
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    course: state.courseDetails.course
  };
}), _dec(_class = _dec2(_class = injectIntl(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(GoToNextSection, _React$Component);
  var _super = _createSuper(GoToNextSection);
  function GoToNextSection() {
    _classCallCheck(this, GoToNextSection);
    return _super.apply(this, arguments);
  }
  _createClass(GoToNextSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        goToNextSectionItemProgress = _this$props.goToNextSectionItemProgress,
        nextItem = _this$props.nextItem,
        nextUrl = _this$props.nextUrl,
        nextPath = _this$props.nextPath,
        course = _this$props.course,
        cancelGoToNextSectionItem = _this$props.cancelGoToNextSectionItem,
        width = _this$props.width,
        nextPodcastItemClickHandler = _this$props.nextPodcastItemClickHandler,
        isPodcastStyle = _this$props.isPodcastStyle;
      var isPodcast = course.type === 'podcast' || isPodcastStyle;
      var size = 140;
      if (width === 'xs') {
        size = 64;
      } else if (width === 'sm') {
        size = 96;
      }
      if (isPodcast) {
        size = 64;
      }
      return /*#__PURE__*/_jsx("div", {
        className: classNames(s.nextSectionItemView, _defineProperty({}, s.podcast, isPodcast))
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: classNames(s.upNext, _defineProperty({}, s.podcast, isPodcast))
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.upNextText)), /*#__PURE__*/_jsx(Typography, {
        variant: "h1",
        className: classNames(s.nextSectionItemTitle, _defineProperty({}, s.podcast, isPodcast))
      }, void 0, _.get(nextItem, 'item.name', '')), /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "YYUtANAYCuBVTibNusY8F",
        className: classNames(s.timeOutProgressWrapper, _defineProperty({}, s.podcast, isPodcast)),
        component: isPodcast ? 'button' : Link,
        to: nextPath || "/courses/".concat(course.slug, "/").concat(nextUrl),
        onClick: nextPodcastItemClickHandler
      }, void 0, /*#__PURE__*/_jsx(CircularProgress, {
        className: s.timeOutProgress,
        variant: "determinate",
        size: size,
        thickness: 3,
        value: goToNextSectionItemProgress
      }), /*#__PURE__*/_jsx(PlayIcon, {
        className: classNames(s.playNextSectionItemIcon, _defineProperty({}, s.podcast, isPodcast))
      })), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "gpZlICL0Dv1LA7HingtaA",
        onClick: cancelGoToNextSectionItem,
        className: classNames(s.cancelNextSectionItemBtn, _defineProperty({}, s.podcast, isPodcast)),
        fullWidth: true
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.cancel)));
    }
  }]);
  return GoToNextSection;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  nextPodcastItemClickHandler: _.noop,
  nextUrl: '',
  nextPath: '',
  isPodcastStyle: false
}), _class2)) || _class) || _class) || _class) || _class);
export { GoToNextSection as default };